<form [formGroup]="formGroup" class="dynamic-form">
  <div class="row case-details">
    <div class="col-md-6" *ngFor="let field of fields" [ngSwitch]="field.type">

      <!-- TextBox -->
      <!-- Deliberately no maxlength attribute: an input that silently stops accepting keystrokes
           reads as "I finished", not "you hit the limit". Length is reported through mat-error
           like every other rule the admin set in the builder. -->
      <mat-form-field *ngSwitchCase="fieldType.Text" class="example-full-width">
        <mat-label>{{ field.label }}</mat-label>
        <input matInput [formControlName]="field.key" [required]="!!field.required" [readonly]="!!field.readOnly">
        <mat-error>{{ errorFor(field) }}</mat-error>
      </mat-form-field>

      <!-- Date: the control holds a Date object, editable through the calendar toggle.
           Typing is blocked (readonly input) so the value can only come from the picker,
           which keeps it a valid Date.
           Deliberately ngx-mat-datetime-picker with hideTime, NOT Material's MatDatepicker:
           both ship unencapsulated .mat-calendar-* styles, so having both in the app makes the
           calendar layout depend on which one was instantiated first. See styles.css.
           hideTime drops the panel's time spinners; appDateOnlyFormat drops the time from the
           input text, which the app-wide format would otherwise render as ' 00:00:00'. -->
      <mat-form-field *ngSwitchCase="fieldType.Date" class="example-full-width">
        <mat-label>{{ field.label }}</mat-label>
        <input matInput appDateOnlyFormat [ngxMatDatetimePicker]="datePicker" [formControlName]="field.key"
               [required]="!!field.required" readonly (click)="openPicker(datePicker, field)">
        <mat-datepicker-toggle matSuffix [for]="datePicker" [disabled]="isDateFieldLocked(field)">
        </mat-datepicker-toggle>
        <ngx-mat-datetime-picker #datePicker [disabled]="isDateFieldLocked(field)"
                                 [hideTime]="true">
        </ngx-mat-datetime-picker>
        <mat-error>{{ errorFor(field) }}</mat-error>
      </mat-form-field>

      <!-- Date & Time: one control, one input. ngx-mat-datetime-picker owns both halves, so
           unlike a plain MatDatepicker there is no separate time input to keep in sync. -->
      <mat-form-field *ngSwitchCase="fieldType.DateTime" class="example-full-width">
        <mat-label>{{ field.label }}</mat-label>
        <input matInput [ngxMatDatetimePicker]="dateTimePicker" [formControlName]="field.key"
               [required]="!!field.required" readonly (click)="openPicker(dateTimePicker, field)">
        <mat-datepicker-toggle matSuffix [for]="dateTimePicker" [disabled]="isDateFieldLocked(field)">
        </mat-datepicker-toggle>
        <ngx-mat-datetime-picker #dateTimePicker [disabled]="isDateFieldLocked(field)"
                                 [showSpinners]="true" [showSeconds]="false"
                                 [stepHour]="1" [stepMinute]="1">
        </ngx-mat-datetime-picker>
        <mat-error>{{ errorFor(field) }}</mat-error>
      </mat-form-field>

      <!-- Dropdown -->
      <mat-form-field *ngSwitchCase="fieldType.Dropdown" class="example-full-width">
        <mat-label>{{ field.label }}</mat-label>
        <mat-select [formControlName]="field.key" [required]="!!field.required">
          <mat-option *ngIf="!field.required" [value]="null">None</mat-option>
          <mat-option *ngFor="let opt of field.options" [value]="opt.value">{{ opt.label }}</mat-option>
        </mat-select>
        <mat-error>{{ errorFor(field) }}</mat-error>
      </mat-form-field>

      <!-- Checkbox -->
      <div *ngSwitchCase="fieldType.Checkbox" class="checkbox-field">
        <mat-checkbox [formControlName]="field.key" [required]="!!field.required">{{ field.label }}</mat-checkbox>
      </div>

      <div *ngSwitchDefault>
        <small class="text-muted">Unsupported field type: {{ field.type }}</small>
      </div>

    </div>
  </div>
</form>
